import {
  SHOW_LOADER,
  HIDE_LOADER,
  SET_FEEDBACK_ALERT,
  UPDATE_LICENSE_SUCCESSED,
  UPDATE_LICENSE_FAILED,
} from '../../constants/actionTypes';

const initialState = {
  showLoader: false,
  feedbackMessage: '',
  feedbackType: '',
  module: '',
  licenseInfo: ''
};

export const appStore = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_LOADER: {
      return { ...state, showLoader: true };
    }
    case HIDE_LOADER: {
      return { ...state, showLoader: false };
    }
    case SET_FEEDBACK_ALERT: {
      return { ...state, ...action.payload };
    }
    case UPDATE_LICENSE_FAILED: {
      return { ...state, licenseInfo: '' };
    }
    case UPDATE_LICENSE_SUCCESSED: {
      return { ...state, licenseInfo: action.data };
    }
    default: {
      return state;
    }
  }
};

export default appStore;
